<template>
    <div class="appdetail">
        <el-drawer :visible.sync="drawer" custom-class="detailDrawer" size="100%" :withHeader="false" :modal-append-to-body="true" :modal="false" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.5)">
            <!-- 标题、按钮 -->
            <div class="appdetail-title">
                <div class="appdetail-title-top clearfix">
                    <div class="app-titles">
                        <i :class="currentSelectMenuData.css" class="app-title-icon"></i>
                        <span class="app-title-main">{{modelflow.name}}</span> 
                    </div>
                    <div class="app-buttons">
                        <i class="el-icon-close appdetail-close" @click="closeBtn"></i>
                    </div>
                </div>
                <div class="appdetail-title-top clearfix">
                    <div class="app-titles app-titles1">
                        <i v-if="!!modelflow.createuserdesc" class="el-icon-time ml5"></i>
                        <span v-if="!!modelflow.createuserdesc" class="ml5">{{modelflow.createuserdesc}}</span>
                        <span class="ml5">创建于</span>
                        <span v-if="!!modelflow.createuserdesc" class="ml5" style="color: #08979c">{{$moment(modelflow.createtime).fromNow()}}</span>
                        <i v-if="!!modelflow.updateuserdesc" class="el-icon-time ml10"></i>
                        <span v-if="!!modelflow.updateuserdesc" class="ml5">{{modelflow.updateuserdesc}}</span>
                        <span class="ml5">更新于</span>
                        <span v-if="!!modelflow.updatetime" class="ml5" style="color: #08979c">{{$moment(modelflow.updatetime).fromNow()}}</span>
                    </div>
                    <div class="app-buttons">
                        <el-button icon="icon-save" class="btn-" type="primary" size="mini" @click="saveBtn">
                            <font>保存</font>
                        </el-button>
                    </div>
                </div>
            </div>
            <div class="appdetail-content" :style="{height: 'calc(100vh - 91px)'}">
                <el-form inline-message :model="modelflow" :rules="rules" label-width="100px" ref="modelflow">
                    <div class="accordion" id="information">
                    <el-collapse v-model="activeNames">
                        <el-collapse-item title="新建模型" name="1">
                        <el-col :span="8">
                            <el-form-item label="模型标识" prop="key">
                            <el-input v-model="modelflow.key"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="模型类型" prop="category">
                            <el-input v-model="modelflow.category"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="模型名称" prop="name">
                            <el-input v-model="modelflow.name"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="模型描述" prop="description">
                            <el-input v-model="modelflow.description"></el-input>
                            </el-form-item>
                        </el-col>
                        </el-collapse-item>

                    </el-collapse>
                    </div>
                </el-form>
            </div>
        </el-drawer>
      <iframemask ref="childiframe"></iframemask>
  </div>
</template>

<script>

import iframemask from './iframe.vue'
export default {
  name: 'masks',
  components: {
    iframemask
  },
  data() {
    return {
      drawer:false,
      loading: false,
      falg: false,//保存验证需要的
      basic_url: Config.dev_url,
      selUser: [],
      edit: true, //禁填
      isok1: true,
      isok2: false,
      modelId: '',
      activeNames: ['1'], //手风琴数量
      rules: { //定义需要校验数据的名称
        key: [{ required: true, message: '请填写模型标识', trigger: 'blur' }],
        category: [{ required: true, message: '请填写模型类型', trigger: 'blur' }],
        name: [{ required: true, message: '请填写模型名称', trigger: 'blur' }],
        description: [{ required: true, message: '请填写模型描述', trigger: 'blur' }],
      },
      modelflow: {},
    };
  },
  methods: {
    reset() {
      this.modelflow = {
        key: '',
        category: '',
        name: '',
        description: '',
      }
    },
    //添加显示弹窗
    addBtn() {
        this.$store.commit('setmenuAndDrawer',true)
        this.modelflow = {
            key: '',
            category: '',
            name: '',
            description: '',
        };
        this.drawer = true
    },
    //点击关闭按钮
    close() {
      this.show = false;
      this.$emit('request');
      this.reset();
    },
    // toggle(e) {
    //   if (this.isok1 == true) {
    //     this.maxDialog();
    //   } else {
    //     this.rebackDialog();
    //   }
    // },
    // maxDialog(e) { //定义大弹出框一个默认大小
    //   this.isok1 = false;
    //   this.isok2 = true;
    //   $(".mask_div").width(document.body.clientWidth);
    //   $(".mask_div").height(document.body.clientHeight - 60);
    //   $(".mask_div").css("top", "0px");
    //   $(".mask_divbg").css("top", "0px");
    // },
    // //还原按钮
    // rebackDialog() { //大弹出框还原成默认大小
    //   this.isok1 = true;
    //   this.isok2 = false;
    //   $(".mask_div").css("width", "80%");
    //   $(".mask_div").css("height", "90%");
    //   $(".mask_div").css("top", "0px");
    //   $(".mask_divbg").css("top", "40px");
    // },
    // 保存users/saveOrUpdate
    saveBtn() {
      this.$refs.modelflow.validate((valid) => {
        if (valid) {
          var url = Config.dev_url + '/api-flow/flow/model/create';
          this.$axios.get(url, {
            params: {
              key: this.modelflow.key,
              category: this.modelflow.category,
              name: this.modelflow.name,
              description: this.modelflow.description,
            }
          }).then((res) => {
            this.modelId = res.data.modelId;
            if (res.status == 200) {
              this.$refs.childiframe.visible(res.data.modelId);
            }
          }).catch((err) => {
          });
        } else {

        }
      });
    },
    //关闭抽屉按钮点击
    closeBtn(){
        this.drawer = false
        this.$emit("requestData")
    },
    //获取创建人描述
    getcreateuserdesc() {
        if (!!this.modelflow.createuser) {
            var url = Config.dev_url + '/api-user/users/' + this.modelflow.createuser
            this.$axios.get(url).then((res) => {
                this.$set(this.modelflow, 'createuserdesc', res.data.nickname)
            }).catch((err) => {
            });
        }
    },
    //获取修改人描述
    getupdateuserdesc() {
        if (!!this.modelflow.updateuser) {
            var url = Config.dev_url + '/api-user/users/' + this.modelflow.updateuser
            this.$axios.get(url).then((res) => {
                this.$set(this.modelflow, 'updateuserdesc', res.data.nickname)
            }).catch((err) => {
            });
        }
    },
    //计算抽屉大小
    initDetailDrawer(){
        if((document.documentElement.clientWidth * 0.7) < 900){
            document.getElementsByClassName("detailDrawer")[0].parentNode.parentNode.style.left = "calc(100% - 900px)"
        }else{
            document.getElementsByClassName("detailDrawer")[0].parentNode.parentNode.style.left = "30%"
        }
    },
  },
  mounted() {
    this.initDetailDrawer()  //初始化计算详情抽屉高度
        //窗口大小发生变化时，重新计算详情抽屉高度
        window.onresize = ()=> {
            if(document.getElementsByClassName("detailDrawer").length > 0){
                this.initDetailDrawer()
            }
        }
  },
  computed:{
        //当前左侧菜单选中的信息
        currentSelectMenuData(){
            return this.$store.state.currentSelectMenuData
        },
        //左侧菜单以及应用详情抽屉显示状态
        menuAndDrawer(){
            return this.$store.state.menuAndDrawer
        },
        //当前登录人信息
        currentuser() {
            return this.$store.state.currentuser
        },
    },
    watch:{
        //左侧菜单点击关闭抽屉
        menuAndDrawer(val){
            this.drawer = val
        },
    },
}
</script>

<style>
</style>
